import {toast} from "react-toastify";
import Product from "../../http_request/Model/product/Product";

const GetProductList = (setProductList, setLoading) => {


    Product.request({
        beforeSend: () => {
            setLoading(true)
        },
        success: (result) => {
            setProductList(result)
        },
        error: ({error}) => {
            toast.error(error.data.message);
        },
        final: () => {
            setLoading(false)
        },
    }).addParams({page: 1, page_size: 100000}).productList()

}
export default GetProductList